const useCurrentLocation = (): string => {
  let pathname = location.pathname;
  pathname += location.search ? location.search : "";
  pathname += location.hash ? `#${location.hash}` : "";

  return pathname;
};

export { useCurrentLocation };
